export const testText = (field, lng) => field.length >= lng;

export const testPhone = (field, min, max) => {
  // eslint-disable-next-line no-useless-escape
  const reg = /^[\+]?[0-9]{2}[0-9]{9}|^[0-9]{9}$|^[0-9]{3}$/gm;
  // eslint-disable-next-line no-param-reassign
  field = field.replace(/ /g, '');
  const lng = field.length;
  return reg.test(field) && lng >= min && lng <= max;
};

export const testDigits = (field, min, max) => {
  const reg = /^\d+$/;
  return reg.test(field) && field >= min && field <= max;
};
